import React from "react"
import _ from "lodash"

import onEnterOrSpace from "@helper/onEnterOrSpace"
import { useQuiz } from "@Quiz/context"
import { ContainedImgWithCredit } from "@Quiz/Ui/ContainedImg"

const extractMultipleChoiceTryAgainWrongMarkings = (tryAgain?: Quiz.Api.QuestionEval["try_again"]): number[] => {
  if (!tryAgain) { return [] }
  if ("type" in tryAgain) {
    if (tryAgain.type === "multiple_choice") {
      return tryAgain.wrong_picked_options ?? []
    }
  } else {
    // deprecated
    if ("wrong_picked_values" in tryAgain) {
      return tryAgain.wrong_picked_values ?? []
    }
  }
  return []
}

export const MultipleChoiceResultInfo: React.FC<{ question: Quiz.Api.MultipleChoiceQuestion}> = () => {
  return <div data-testid="multiple-choice-result-info" />
}

const MultipleChoiceAnswers: React.FC = () => {
  const { quiz, actions } = useQuiz()
  if (!(quiz?.question?.config?.type === "multiple_choice")) { return null }
  const config = quiz.question.config
  return (
    <div className="neo__multipleChoiceAnswers" data-testid="multiple-choice-answers">
      {_.map(config.options, (opt, index) => {
        const markWrong = extractMultipleChoiceTryAgainWrongMarkings(quiz?.question?.eval?.try_again).indexOf(opt.val) > -1
        return (
          <AnswerButton
            key={index}
            answer={opt}
            marking={markWrong ? "wrong" : undefined}
            onClick={() => actions.answerQuestion({ type: "multiple_choice", picked_option: opt.val })} />
        )
      })}
    </div>
  )
}

export type AnswerMarking = "correct" | "wrong"

const AnswerButton: React.FC<{marking?: AnswerMarking, onClick(): void, answer: Quiz.Api.AnswerOptionBase}> = ({answer, marking, onClick}) => {
  const className = [
    "neo__answerButton",
    marking === "wrong" ? "neo__answerButton--markWrong" : "",
    marking === "correct" ? "neo__answerButton--markCorrect" : "",
  ].join(" ")

  const canPick = !marking // canPick if not already marked

  const Inner = <>
    {answer.image &&
      <span className="neo__answerButton__image">
        <ContainedImgWithCredit src={answer.image["1x"]} credit={answer.image_credit} classForImg={`neo__answerButton__image__img neo__answerButton__image__img--${answer.image_display_size ?? "default"}`} />
      </span>}
    {answer.text &&
      <span className="neo__answerButton__text" dangerouslySetInnerHTML={{__html: answer.text}} />}
  </>

  return (
    <div className="neo__answerButtonHolder">
      {canPick
        ? <a className={className} role="button" tabIndex={0} onClick={onClick} onKeyDown={onEnterOrSpace(onClick)}>
            {Inner}
          </a>
        : <span className={className}>{Inner}</span>}
    </div>
  )
}

export default MultipleChoiceAnswers
